import { apis, RequestOptions } from "../../backend";
import { BooleanOrAny } from "../../models/BooleanOrAny";
import { Project } from "../../models/Project";

export type ProjectQuery = {
  organizationIds?: string[];
  anyOrganization?: boolean;
  isDeleted?: BooleanOrAny;
}

export async function listProjects(query?: ProjectQuery): Promise<Project[]> {
  const projects = await apis.users.get<Project[]>('/projects-v1', query);

  return projects.map(project => new Project(project));
}

export type SimpleProject = Pick<Project, 'id' | 'name'>;

export async function listSimpleProjects(options?: RequestOptions): Promise<SimpleProject[]> {
  const projects = await apis.users.get<SimpleProject[]>('/project-information-v1/simple', null, options);
  return projects;
}